// extracted by mini-css-extract-plugin
export default {"container":"common-photo-carousel-CarouselProgress__container--3y8KU","text":"common-photo-carousel-CarouselProgress__text--1Urck"};